import forBasicControl from "./forBasicControl";
import { IControlProps, IListOption, IBasicControlDefinition } from "./types";
import React, { PureComponent } from "react";
import { FormGroup, FormFeedback } from "reactstrap";
import { createLabel } from "./BasicControls";
import LabelWithToolTip from "../LabelWithToolTip";
import Select from 'react-select';
import classNames from "classnames";

import './MultiOptionControl.scss';

export interface IOptionSetControl extends IBasicControlDefinition {
    loadOptions: (context: any) => Promise<IListOption<string>[]>
    addDefault: boolean;
}

interface ISelectOption {
    label: string;
    value: string;
}
interface IState {
    loadError: boolean;
    options: ISelectOption[];
    output: string[];
    value: ISelectOption[];
}

class MultiOptionSetControl extends PureComponent<IControlProps<string[], IOptionSetControl>, IState> {
    constructor(props) {
        super(props);

        this.state = {
            loadError: false,
            options: null,
            output: null,
            value: [],
        };
    }
    private mountState = false;
    public componentDidMount() {
        this.mountState = true;
        if (!this.state.options) {
            this.load();
        }
        this.setState({
            value: this.mapValue(this.props.value || []),
            output: this.props.value,
        });
    }
    public componentWillUnmount() {
        this.mountState = false;
    }
    public componentDidUpdate(prev: IControlProps<any[], IOptionSetControl>) {
        if (this.props.context !== prev.context)
            this.load();
        if (this.props.value !== prev.value)
            this.setState({
                value: this.mapValue(this.props.value || []),
                output: this.props.value,
            });
    }
    private mapValue(value: string[]): ISelectOption[] {
        return value.map((x) => {
            const opt = this.state.options && this.state.options.find((y) => y.value === x);
            return opt || { label: x, value: x };
        });
    }
    private async load() {
        try {
            const data = await this.props.definition.config.loadOptions(this.props.context);

            if (!this.mountState)
                return;

            this.setState({ 
                loadError: false, 
                options: data,
            }, () => this.setState({ value: this.mapValue(this.state.output) }));
        }
        catch (e) {
            if (!this.mountState)
                return;

            this.setState({ loadError: true, options: [] });
        }
    }
    private onChange(value: ISelectOption[]) {
        let result: string[]
        
        if (!value || value.length === 0)  {
            result = [];
        }
        else {
            result = value.map((x) => x.value);
        }

        if (value !== this.state.value)
            this.setState({ output: result, value });
        if (result !== this.state.output)
            this.props.onChange(result);
    }
    public render() {
        const props = this.props;
        return <>
            <LabelWithToolTip
                label={createLabel(props.definition, true)}
                field={props.definition.key}
                tooltip={props.definition.config.description} />

            <div className={classNames("rs-custom-select-field", { "is-valid": this.props.showValidation && this.props.isValid, "is-invalid": this.props.showValidation && !this.props.isValid })}>
                <Select
                    isMulti
                    isSearchable
                    closeMenuOnSelect={false}
                    placeholder="Selecteer..."
                    classNamePrefix="select-custom"
                    onChange={(value) => this.onChange(value)}
                    options={this.state.options || []}
                    value={this.state.value} />
            </div>
        </>
    }
}

const Control = forBasicControl((props: IControlProps<string[], IOptionSetControl>) =>
    <FormGroup>
        <MultiOptionSetControl {...props} />
        {!props.isValid && <FormFeedback valid={false} >{props.validationMessage}</FormFeedback>}
    </FormGroup>);

export default Control;